import { render, staticRenderFns } from "./table-header.vue?vue&type=template&id=274d9a97&scoped=true"
import script from "./table-header.vue?vue&type=script&lang=js"
export * from "./table-header.vue?vue&type=script&lang=js"
import style0 from "./table-header.vue?vue&type=style&index=0&id=274d9a97&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274d9a97",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('274d9a97')) {
      api.createRecord('274d9a97', component.options)
    } else {
      api.reload('274d9a97', component.options)
    }
    module.hot.accept("./table-header.vue?vue&type=template&id=274d9a97&scoped=true", function () {
      api.rerender('274d9a97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/ui/table/table-header.vue"
export default component.exports